import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-cookie-preferences',
  standalone: false,
  templateUrl: './cookie-preferences.html',
  styleUrl: './cookie-preferences.less'
})
export class CookiePreferences {

  @Input() isOpen = false;

  @Output() close = new EventEmitter<void>();

  preferences = {
    necessary: true,
    analytics: false,
    marketing: false
  };

  ngOnInit(): void {
    this.loadPreferences();
  }

  loadPreferences(): void {

    const savedPreferences = localStorage.getItem('cookiePreferences');

    if (savedPreferences) {
      this.preferences = JSON.parse(savedPreferences);
    }
  }

  // ngOnChanges(changes: SimpleChanges): void {

  //   if (changes['isOpen']?.currentValue) {
  //     this.loadPreferences();
  //   }
  // }
  savePreferences(): void {

    localStorage.setItem(
      'cookiePreferences',
      JSON.stringify(this.preferences)
    );

    this.closeModal();
  }

  acceptAll(): void {

    this.preferences = {
      necessary: true,
      analytics: true,
      marketing: true
    };

    this.savePreferences();
  }

  rejectAll(): void {

    this.preferences = {
      necessary: true,
      analytics: false,
      marketing: false
    };

    this.savePreferences();
  }

  closeModal(): void {
    this.close.emit();
  }

}